var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgServiceTruck = function SvgServiceTruck(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14830_3210)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M509.654 -97.4434H-223.27V192.794H509.654V-97.4434Z",
    stroke: "black",
    strokeWidth: 4.06778
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59 6.10877C59 5.48643 58.795 4.88312 58.4155 4.3883L56.6142 2.04075C56.0792 1.34324 55.2468 0.933105 54.3666 0.933105H17.6448C16.7637 0.933105 15.9198 1.34324 15.3858 2.04075L13.5845 4.3883C13.205 4.88407 13 5.49024 13 6.11352L13.0076 8.58193C13.0076 8.72372 13.0229 8.86074 13.0429 8.99682V58.0081C13.0429 65.2087 18.9131 71.0676 26.1306 71.0676H45.8685C53.085 71.0676 58.9561 65.2087 58.9561 58.0081V9.0444C58.9819 8.8912 58.999 8.73513 58.999 8.57527L59 6.10877Z",
    fill: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7376 5.28948L54.8949 2.88916H17.3476H17.3359L15.4941 5.28948L15.5 7.81337H56.7357L56.7376 5.28948Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5942 44.3887H14.6367V58.8772H57.5942V44.3887Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5942 12.1226H14.6367V26.6121H57.5942V12.1226Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3662 5.09619H44.0042V6.68992H55.4644V58.3587C55.4644 63.46 51.3206 67.5961 46.2077 67.5961H26.0262C20.9133 67.5961 16.7695 63.46 16.7695 58.3587V6.68992H28.3681L28.3662 5.09619Z",
    fill: "#F9BA15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8283 6.82031H17.3438V22.6379H28.8283V6.82031Z",
    fill: "#C68106",
    stroke: "black",
    strokeWidth: 1.14643
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.088 6.82031H43.6016V22.6379H55.088V6.82031Z",
    fill: "#F9BA15",
    stroke: "black",
    strokeWidth: 1.14643
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.2969 66.9841V23.0972H55.103V60.5751C54.1533 62.9628 53.5898 64.8095 49.2969 66.9841Z",
    fill: "#C68106"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8217 66.9841V23.0972H17.0137V60.5751C17.9662 62.9628 18.5278 64.8095 22.8217 66.9841Z",
    fill: "#C68106"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5293 22.6616H56.1484",
    stroke: "black",
    strokeWidth: 1.14643
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1799 4.85303H44.2499V6.69H55.4624V58.3588C55.4624 63.4601 51.3186 67.5962 46.2057 67.5962H26.0242C20.9113 67.5962 16.7676 63.4601 16.7676 58.3588V6.69H28.1799V4.85303Z",
    stroke: "black",
    strokeWidth: 2.29287
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6752 11.6152H19.8047V22.2206H28.6752V11.6152Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9359 12.8618H20.8594V15.6066H27.9359V12.8618Z",
    fill: "#BDBDBD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14830_3210"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46.8,
    height: 72,
    fill: "white",
    transform: "translate(12.5996)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgServiceTruck);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "service-truck.e8b4476c931d00c8e86e99b33d560a69.svg";